import { ProfessionIcon } from './profession-icon';

export const IconDaycare = () => (
  <ProfessionIcon bg="#E8F5E9">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <circle cx="9" cy="7" r="3" stroke="#4CAF50" strokeWidth="1.8" />
      <circle cx="17" cy="9" r="2" stroke="#4CAF50" strokeWidth="1.8" />
      <path
        d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2"
        stroke="#4CAF50"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M17 14c2.21 0 4 1.34 4 3v4"
        stroke="#4CAF50"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  </ProfessionIcon>
);
